<template>
  <Container>
    <p
      class="text-center tablet:w-2/3 mx-auto"
    >
      {{ t('jc.view.user-index.helpText') }}
    </p>
  </Container>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>
